//商品接口相关的函数
import request from "../utils/request"


//查询当前登录用户的应用分组和应用
export let getForumAreaStudy = (params) => request.get('/study/forum/area/getForumAreaStudy', {params})
export let getForumAreaBykeyCode = (params) => request.get('/study/forum/area/getForumAreaBykeyCode', {params})
export let getForumInfoByLevel = (params) => request.get('/study/forum/info/getForumInfoByLevel',{params})
export let getForumAreaGradeAndSpecialty = (params) => request.get('/study/forum/area/getForumAreaGradeAndSpecialty',{params})
export let insertForumPost = (params) => request.post('/study/forum/info/insertForumPost',params)
export let getForumAreaCourse = (params) => request.get('/study/forum/area/getForumAreaCourse',{params})
export let getForumTitleById = (params) => request.get('/study/forum/info/getForumTitleById',{params})

export let getForumReplyById = (params) => request.get('/study/forum/info/getForumReplyById',{params})












